import { AuthProvider } from 'ra-core';

const authProvider: AuthProvider = {
    login: params => {
        const { username, password } = params;
        const request = new Request(
            process.env.REACT_APP_REST_API_URL + '/auth/signin',
            {
                method: 'POST',
                body: JSON.stringify({ username, password }),
                headers: new Headers({ 'Content-Type': 'application/json' }),
            }
        );
        return fetch(request, { credentials: 'include' })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data && data.roles) {
                    if (!data.isRegional && !data.isNational && !data.isAdmin) {
                        //Clear localstorage
                        localStorage.removeItem('user');
                        localStorage.removeItem('role');
                        localStorage.removeItem('visibility');
                        localStorage.removeItem('region');
                        authProvider.logout({});
                        return Promise.reject(new Error('Accès non autorisé'));
                    }
                    localStorage.setItem('user', data);

                    if (!!data.isAdmin) {
                        localStorage.setItem('visibility', 'admin');
                    } else if (!!data.isNational) {
                        localStorage.setItem('visibility', 'national');
                    } else if (!!data.isRegional) {
                        localStorage.setItem('visibility', 'regional');
                        localStorage.setItem('region', data.region);
                    }
                    localStorage.setItem('role', data.roles[0]);
                    //redirect to alerts page after each login
                    return Promise.resolve();
                } else {
                    throw new Error(data.message);
                }
            })
            .catch(err => {
                console.error(err);
                return Promise.reject(err);
            });
    },
    logout: params => {
        //Clear localstorage
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        localStorage.removeItem('visibility');
        localStorage.removeItem('region');
        //Logout from server
        const logout_request = new Request(
            process.env.REACT_APP_REST_API_URL + '/auth/signout',
            {
                method: 'GET',
                headers: new Headers({ 'Content-Type': 'application/json' }),
            }
        );

        return fetch(logout_request, { credentials: 'include' })
            .then(response => {
                return Promise.resolve();
            })
            .catch(err => {
                console.error('logout err');
                console.error(err);
                return Promise.resolve();
            });
    },
    checkError: params => {
        const status = params.status;
        // if (status === 500 || status === 401) {
        //   localStorage.removeItem("user");
        //   localStorage.removeItem("role");
        //   localStorage.removeItem('visibility');
        //   localStorage.removeItem('region');
        //   return Promise.reject();
        // }
        if (status === 401) {
            localStorage.removeItem('user');
            localStorage.removeItem('role');
            localStorage.removeItem('visibility');
            localStorage.removeItem('region');
            return Promise.reject();
        }
        // return Promise.resolve(new Error(params.message));
        return Promise.resolve();
    },
    checkAuth: params => {
        return localStorage.getItem('user') && localStorage.getItem('role')
            ? Promise.resolve()
            : Promise.reject();
    },
    getPermissions: params => {
        const role = localStorage.getItem('role');
        return role ? Promise.resolve(role) : Promise.reject();
    },
};

export default authProvider;
